import { SectionCard } from '@/components/SectionCard'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/features/auth/hooks/useAuth'
import { useGetBeds } from '@/features/beds/hooks/useBed'
import { ItemSummaryStats } from '@/features/items/components/ItemSummaryStats'
import { ArrowLeft, Building2, MapPin, Monitor, Users } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { BedList } from '../../beds/components/BedList'
import { useGetDepartment, useGetDepartmentItems } from '../hooks/useDepartment'
import { DepartmentDialog } from './DepartmentDialog'
import { DepartmentItemList } from './DepartmentItemList'

type DepartmentViewProps = {
  departmentId: string
}

export function DepartmentView({ departmentId }: DepartmentViewProps) {
  const { t } = useTranslation()
  const { isAdmin } = useAuth()
  const { data: department, isLoading: isLoadingDepartment } = useGetDepartment(departmentId!)
  const { data: departmentItems, isLoading: isLoadingDepartmentItems } = useGetDepartmentItems(departmentId!)
  const { data: beds = [], isLoading: isLoadingBeds } = useGetBeds(departmentId!)

  const navigate = useNavigate()

  const [selectedDepartmentId, setSelectedDepartmentId] = useState<string | null>(null)
  const [editDepartmentOpen, setDepartmentOpen] = useState(false)

  const canManage = isAdmin

  const bedItems = beds.filter(bed => bed.departmentId === departmentId)
  return (
    <div className="flex flex-col space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-[auto_1fr_auto] items-start gap-4">
        <div className="justify-self-start md:row-start-1 md:col-start-1">
          <Button
            data-testid="department-detail-back"
            variant="ghost"
            size="sm"
            className="h-8 text-xs text-muted-foreground"
            onClick={() => {
              navigate(`/departments`)
            }}
          >
            <ArrowLeft className="mr-1 size-3" />
            {t('common.back')}
          </Button>
        </div>

        <div className="col-span-2 md:col-span-1 md:col-start-2 row-start-2 md:row-start-1 flex justify-center w-full">
          <div className="w-full md:max-w-xl md:px-5">
            <SectionCard
              cardClass="border-border/50 bg-card transition-all "
              headerClass="pb-0"
              header={
                <div className="flex flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <Building2 className="size-4 shrink-0 text-primary" />
                    <span className="text-sm font-semibold text-foreground break-all line-clamp-2">
                      {department?.name}
                    </span>
                  </div>
                  <div className="flex items-center gap-3 text-xs text-muted-foreground">
                    <span className="flex items-center gap-1">
                      <MapPin className="size-3" />
                      {t('common.floor')} {department?.floor?.name}
                    </span>
                    <span className="flex items-center gap-1">
                      <Users className="size-3" />
                      {department?.head?.name}
                    </span>
                  </div>
                </div>
              }
              right={
                <>
                  {/* {canManage && (
                    <Button
                      variant={'outline'}
                      size="sm"
                      className="h-6"
                      onClick={e => {
                        e.stopPropagation()
                        setSelectedDepartmentId(departmentId)
                        setDepartmentOpen(true)
                      }}
                    >
                      <Edit2 className="size-3" />
                    </Button>
                  )} */}
                  <Badge variant="outline" className="text-[11px] text-muted-foreground">
                    <Monitor className="mr-1 size-3" />
                    {departmentItems?.department?.itemSummary?.total}
                  </Badge>
                </>
              }
            >
              <ItemSummaryStats summary={departmentItems?.department?.itemSummary}></ItemSummaryStats>
            </SectionCard>
          </div>
        </div>

        {/* <div className="justify-self-end md:row-start-1 md:col-start-3">
          {canManage ? (<Button size="sm" className="h-8 text-xs" onClick={() => { setDepartmentOpen(true) }}>
            <Edit2 className="size-3" />แก้ไข
          </Button>
          ) : (
            <div className="w-[60px]" />
          )}
        </div> */}
      </div>

      <BedList departmentId={departmentId} beds={bedItems}></BedList>

      <DepartmentItemList
        department={departmentItems?.department}
        items={departmentItems?.items ?? []}
      ></DepartmentItemList>

      <DepartmentDialog
        open={editDepartmentOpen}
        onOpenChange={setDepartmentOpen}
        departmentId={selectedDepartmentId!}
      ></DepartmentDialog>
    </div>
  )
}
